import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';

import { TabMenuModule } from 'primeng/tabmenu';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { SidebarModule } from 'primeng/sidebar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { SplitterModule } from 'primeng/splitter';

import { ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FailedComponent } from './failed/failed.component';

import { HttpClientModule } from '@angular/common/http';
import {
  IPublicClientApplication,
  PublicClientApplication,
  BrowserCacheLocation,
  LogLevel,
  InteractionType
} from '@azure/msal-browser';
import {
  MsalGuard,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalGuardConfiguration,
  MsalRedirectComponent
} from '@azure/msal-angular';

import { environment } from '../environments/environment';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { FormulariosComponent } from './formularios/formularios.component';
import { FormularioComponent } from './formulario/formulario.component';
import { FormProyectoComponent } from './form-proyecto/form-proyecto.component';
import { PrimeNgModule } from './primeng.module';
import { EditarformularioComponent } from './editarformulario/editarformulario.component'; 
import { EditarformularioPromocionesComponent } from './editarformulario-promociones/editarformulario-promociones.component';
import { FormSolicitudesComponent } from './form-solicitudes/form-solicitudes.component';
import { FormsModule } from '@angular/forms';
import { DataService } from './data.service';
import { FormPropiedadesComponent } from './form-propiedades/form-propiedades.component';
import { FormResultadosComponent } from './form-resultados/form-resultados.component';
import { FormDevolverComponent } from './form-devolver/form-devolver.component';
import { FormUsuariosComponent } from './form-usuarios/form-usuarios.component';
import { FormEstadisticasComponent } from './form-estadisticas/form-estadisticas.component';
import { FormPrecargarComponent } from './form-precargar/form-precargar.component';
import { CrearcontrasenaComponent } from './crearcontrasena/crearcontrasena.component';
import { CrearencuestaComponent } from './crearencuesta/crearencuesta.component';
import { CrearusuarioComponent } from './crearusuario/crearusuario.component';
import { EditarusuarioComponent } from './editarusuario/editarusuario.component';
import { EncuestasComponent } from './encuestas/encuestas.component';
import { EditarencuestaComponent } from './editarencuesta/editarencuesta.component';
import { RegistroComponent } from './registro/registro.component';
import { SelectorformularioComponent } from './selectorformulario/selectorformulario.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SafeUrlPipe } from './safe-url.pipe';
import { PppfaComponent } from './pppfa/pppfa.component';
import { SolicitudComponent } from './solicitud/solicitud.component';
import { ParticipantesComponent } from './participantes/participantes.component';
import { ZonaseguraComponent } from './participantes/zonasegura/zonasegura.component';
import { CardModule } from 'primeng/card';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

/** Factory para la instancia MSAL (Microsoft Entra ID - zona participantes) */
export function MSALInstanceFactory(): IPublicClientApplication {
  const config = environment.msalEntraId;
  if (!config) {
    throw new Error('msalEntraId no está definido en environment');
  }
  return new PublicClientApplication({
    auth: config.auth,
    cache: {
      cacheLocation: config.cache?.cacheLocation === 'sessionStorage' ? BrowserCacheLocation.SessionStorage : BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: config.cache?.storeAuthStateInCookie ?? false
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

/** Configuración del MsalGuard para rutas de participantes */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  const config = environment.msalEntraId;
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: config?.scopes ?? ['Entrar_como_participante'] },
    loginFailedRoute: '/login-failed'
  };
}






@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FailedComponent,
    FormulariosComponent,
    FormularioComponent,
    FormProyectoComponent,
    EditarformularioComponent,
    FormPropiedadesComponent,
    FormResultadosComponent,
    FormDevolverComponent,
    FormUsuariosComponent,
    FormEstadisticasComponent,
    FormPrecargarComponent,
    CrearcontrasenaComponent,
    CrearencuestaComponent,
    EncuestasComponent,
    EditarencuestaComponent,
    RegistroComponent,
    SelectorformularioComponent,
    EditarusuarioComponent,
    CrearusuarioComponent,
    ConfiguracionComponent,
    SafeUrlPipe,
    PppfaComponent,
    EditarformularioPromocionesComponent,
    FormSolicitudesComponent,
    SolicitudComponent,
    ParticipantesComponent,
    ZonaseguraComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    NoopAnimationsModule, // Animations cause delay which interfere with E2E tests
    AppRoutingModule,
    MatButtonModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatTableModule,
    HttpClientModule,
    TabMenuModule,
    PrimeNgModule,
    ReactiveFormsModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    FileUploadModule,
    SidebarModule,
    TieredMenuModule,
    TableModule,
    DropdownModule,
    ToastModule,
    DialogModule,
    MultiSelectModule,
    PanelMenuModule ,
    AccordionModule,
    SplitterModule,
    CardModule,
    MsalModule
  ],
  providers: [
    MessageService,
    DataService,
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    MsalService,
    MsalGuard
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }